module.exports = __webpack_public_path__ + "img/albb.3b9678b1.png";